// Third-party Library
import { Progress, Row, Col, Flex } from 'antd'

// Components
import { ChildCard, InfoCard } from './components'
import SVG from '../../../../../v3/components/SVG'

// import { mileageSelector, MILEAGE_TYPE } from '../../../../../v3/handlers/report'
import { DERIVATIVE_DATA_TYPE, speedSelector } from '../../../../../v3/handlers/report'

// style
import styles from '../../index.module.css'
import shl_white from './logo.png'
import car from './asset/car.svg'
import fuel from './asset/fuel.svg'
import speedometer from './asset/speedometer.svg'

const Info = ({
    thisVehicle,
    thisDriver,
    thisVehicleDerivative,
    thisVehicleFuelProfile,
    totalFuel = 0,
    totalMileage = 0
}) => {

    const transitStatus = thisVehicleDerivative?.transitStatus?.toLowerCase()
    const fuel_tankNum = thisVehicleFuelProfile?.tankNum

    const fuelProfile = []

    if(fuel_tankNum) {
        for(let n = 0; n < fuel_tankNum; n++) {
            const vehicleLevel = thisVehicleDerivative[thisVehicleFuelProfile[`${n}_deviceParam`]] || 0
            const vfMax = (thisVehicleFuelProfile && thisVehicleFuelProfile [`${n}_max`]) || 0
            const vfMin = (thisVehicleFuelProfile && thisVehicleFuelProfile [`${n}_min`]) || 0
            const fuelLevel = Number((((vehicleLevel-vfMin) / (vfMax-vfMin)) * 100).toFixed(2))
            fuelProfile.push(isFinite(fuelLevel) ? fuelLevel : 0)
        }
    }

    return (
        <div style={{ overflowY: 'auto' }}>
            <img src={shl_white} className={styles['logo']} alt=""/>
            <div className={styles['info-grid']}>
                <InfoCard 
                    title={'Fuel Info'} 
                    component={
                        <div>
                            {
                                fuelProfile.length && fuelProfile.map((fp, i) => 
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                            <h4>Tank {i+1}</h4>
                                            <h4>{fp}%</h4>
                                        </div>
                                        <Progress percent={fp} showInfo={false} /><br/><br/>
                                    </div>
                                )
                                || 
                                <h4>Undetectable Fuel Level</h4>
                            }
                            <br />
                            {/* <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                    <h4>Fuel Sensor</h4>
                                    <h4>20%</h4>
                                </div>
                                    <Progress percent={20} showInfo={false} />
                            </div> */}
                            <ChildCard component={
                                <Row>
                                    <Col span={12} style={{display: 'flex', alignItems: 'center',  gap: '10px'}}>
                                        <img src={car} alt=''/>
                                        <h3>{totalMileage || 0} Km</h3>
                                    </Col>
                                    <Col span={12} style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                        <img src={fuel} alt=''/>
                                        <h3>{!isNaN(totalFuel) ? totalFuel : 0} L Used</h3>
                                    </Col>
                                </Row>
                            } 
                            />
                        </div>
                    }
                />
                <InfoCard 
                    title={'Driver Info'} 
                    component={
                        <div>
                            <Flex justify={'space-between'}>
                                <h3 style={{ color: '#878787'}}>Driver Name</h3>
                                <h3>{thisDriver?.name || '-'}</h3>
                            </Flex>
                            <Flex justify={'space-between'}>
                                <h3 style={{ color: '#878787'}}>IC Number</h3>
                                <h3>{thisDriver?.icNumber || '-'}</h3>
                            </Flex>
                            <Flex justify={'space-between'}>
                                <h3 style={{ color: '#878787'}}>Plate Number</h3>
                                <h3>{thisVehicle.plate || '-'}</h3>
                            </Flex>
                            <ChildCard component={
                                <Row>
                                    <Col span={12} style={{display: 'flex', gap: '10px'}}>
                                    {
                                        transitStatus
                                        &&
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <SVG 
                                                viewBox="0 0 14 14" 
                                                fill="none" 
                                                size="20"
                                                name={`${transitStatus}-square`}
                                            />
                                            <h3>{transitStatus?.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}</h3>
                                        </div>
                                    }
                                    </Col>
                                    <Col span={12} style={{display: 'flex', gap: '10px'}}>
                                        <img src={speedometer} alt=''/>
                                        <h3>{speedSelector({ ...thisVehicle, ...thisVehicleDerivative }, DERIVATIVE_DATA_TYPE.STATE).toFixed(1) || 0} Km/h</h3>
                                    </Col>
                                </Row>
                            } 
                            />
                        </div>
                    }
                />
            </div>
        </div>
    )
}

export default Info